export default __webpack_public_path__ + "static/media/file.7de96776.svg";